define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/:id/",
      {},
      {
        get:
          cache: true
        getBySlug:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/slug/:slug/"
          cache: true
        submit:
          method: "POST"
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/:id/submit/"
        send_invitation:
          method: "POST"
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/:id/send_invitation/"
        quick_form:
          method: "POST"
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/quick_form/:id/"
        default:
          method: "GET"
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/default/"
        query:
          cache: true
          params:
            limit: 25
          transformResponse: (response) ->
            try
              response = angular.fromJson(response)
            catch e
              response = null
              console.trace e
            response
      }
    )



// WEBPACK FOOTER //
// ./resources/ApplicationTemplate.coffee